import { del, get, post, postMultipart, put } from "../api_helper"
import * as url from "./url"

const postAddTrackingImage = data => postMultipart(url.POST_TRACKING_IMAGE, data)
const deleteTrackingImage = data => del(url.DELETE_TRACKING_IMAGE, data)

export { postAddTrackingImage, deleteTrackingImage }
